import { DataMapStructure } from './data-map';

export const booleanDataMap: DataMapStructure = {
  yes: { key: 'REPORTDATA.yes', fallback: 'Yes' },
  no: { key: 'REPORTDATA.no', fallback: 'No' },
};
